import styled from '@emotion/styled';
import { Color } from '@sunrun/mui-theme';
import { MAX_DESKTOP_BREAKPOINT } from '../components/general/constants/_breakpoints';
import { HEADER_HEIGHT } from '../components/general/constants/_sizes';

const OneColumn = styled.div`
  height: calc(100vh - ${HEADER_HEIGHT});
  overflow-y: auto;
  background-color: ${props => (props.noBkgd ? 'none' : Color.PRIMARY_BLUE_LIGHTEST)};

  @media only screen and (max-width: ${MAX_DESKTOP_BREAKPOINT}) {
    height: 100%;
  }
`;

export default OneColumn;
